export enum ConnectionStatusEnum {
  Connected,
  ConnectionFailed,
  RequiredAction,
  NotConnected,
  WaitForVerification
}
